import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../components/Index.vue'
import Login from '../components/Login.vue'
import {store} from '../lib/store'

Vue.use(VueRouter)

const routes = [
	// Index
	{
		name: 'Index',
		path: '/',
		component: Index,
		meta: {
			title: 'IFK Surveys',
		},
		beforeEnter: (to, from, next) => {
			if (!store.getters.loggedIn) {
				// console.log('redirect')
				next('/login')
			}
			else next()
		}
	},
	// Login
	{
		name: 'Login',
		path: '/login',
		component: Login,
		meta: {
			title: 'IFK Surveys / Login',
		},
		beforeEnter: (to, from, next) => {
			if (store.getters.loggedIn) {
				// console.log('redirect')
				next(false)
			}
			else next()
		}
	},
];

export const router = new VueRouter({
	routes
})
